export default __webpack_public_path__ + "static/media/buildxap_logo.d72f0062.svg";